import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs: ['en', 'fr', 'pt', 'ar'],
        nonExplicitSupportedLngs: true,
        debug: process.env.NODE_ENV === 'development',

        interpolation: { escapeValue: false },

        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        defaultNS: 'translation',

        detection: {
            order: ['path', 'querystring', 'cookie', 'localStorage', 'navigator'],
            lookupFromPathIndex: 0,
            lookupQuerystring: 'lng',
            caches: ['cookie', 'localStorage'],
            excludeCacheFor: ['cimode'],
        },

        react: { useSuspense: false },
        returnNull: false,
    });

export default i18n;
